import * as React from "react";

const SvgIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    fill="none"
    viewBox="0 0 32 32">
    <path
      fill="#E36F6F"
      d="M24.668 19.335c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10 10 4.477 10 10M25.976 3.139a.744.744 0 0 1 1.384 0l.872 2.212a.74.74 0 0 0 .42.42l2.212.872a.744.744 0 0 1 0 1.384l-2.213.872a.74.74 0 0 0-.419.42l-.872 2.211a.744.744 0 0 1-1.384 0l-.872-2.212a.74.74 0 0 0-.42-.419l-2.212-.872a.744.744 0 0 1 0-1.384l2.212-.873a.74.74 0 0 0 .42-.419zM23.358 12.059l1-1-.4-1.013-1.015-.4-1 .999q.77.645 1.415 1.414"></path>
  </svg>
);

export default SvgIcon;
